angular.
module("dx.webapp.support").
directive("dxSupportPin", function supportPinDirective() {
	"use strict";

	return {
		restrict: "E",
		scope: {
			userId: "=",
		},
		templateUrl: "tmpl/support/support-pin-directive.html",
		controller: "DxSupportPinController",
		controllerAs: "vm",
		bindToController: true,
	};
});
